import React, { useCallback, useState, useEffect } from 'react';
import { EditOutlined } from '@ant-design/icons';

import WorkflowActionNode from './WorkflowActionNode';
import WorkflowHandle from './WorkflowHandle';
import UserAssignmentSelector from './selectors/UserAssignmentSelector.js';
import { resolveFormDivisionIds } from '../formHelpers';

const AUTHOR_HELP = 'An edit request will be sent to the form\'s author';

const ERROR_DETAILS = {
  content: (
    <div style={{ maxWidth: 300 }}>
      This step requires the <b>Select Recipient(s)</b> field to be configured.
    </div>
  ),
};

export default ({
  setElements,
  setDataMap,
  isDisplay,
  divisionId,
  divisionIds = [],
  sections = [],
  isExternalForm,
  setDisableNext,
} = {}) => {
  const relevantDivisionIds = resolveFormDivisionIds({ divisionIds, divisionId });

  return ({
  id,
  draggable,
  data = {},
}) => {
  const {
    users: initialSelected = [],
  } = data;
  const [selected,setSelected] = useState(initialSelected);

  useEffect(() => {
    if (!setDisableNext) return;

    setDisableNext((prev) => ({ ...prev, [id]: selected?.length === 0 }));
  }, [selected, setDisableNext, id]);

  const onChange = useCallback((newSelected) => {
    setDataMap((dataMap) => ({
      ...dataMap,
      [id]: { users: newSelected }
    }));
    setSelected(newSelected);
  },[id]);

  return (
    <WorkflowActionNode
      id={id}
      title={'Edit'}
      Icon={EditOutlined}
      type='edit'
      draggable={draggable}
      onNodeUpdate={(...args) => {
        setElements(...args);
        if (setDisableNext) {
          setDisableNext((prev) => ({ ...prev, [id]: false }));
        }
      }}
      isDisplay={isDisplay}
      hover={`
        Users or roles added to this step can edit a submitted form.
      `}
      errorPopover={selected?.length === 0 ? ERROR_DETAILS : null}
    >
      {!draggable && <div>
        <UserAssignmentSelector
          onChange={onChange}
          selected={selected}
          showPositions={true}
          isDisplay={isDisplay}
          divisions={relevantDivisionIds}
          showFields
          sections={sections}
          showFormAuthor={!isExternalForm}
          formAuthorHelperText={AUTHOR_HELP}
        />
        <WorkflowHandle type='target' position='top' disabled={isDisplay}/>
        <WorkflowHandle
          type='source'
          position='bottom'
          id={`${id}-edited`}
          disabled={isDisplay}
        />
      </div>}
    </WorkflowActionNode>
  );
};
};
